<template>
  <div class="map-content">
    <div id="map" class="map"></div>

    <el-dialog title="导入" top="35vh" :modal="false" custom-class="global-window import-window"
      :visible.sync="importDialogVisible" width="440px" @closed="importFinished = false">
      <div class="import-content">
        <span class="name">项目名称：{{ projectInfo?.projectName }}</span>
        <el-upload :disabled="importFinished" class="upload-cad" accept=".dwg" name="fileToUpload"
          :show-file-list="false" :before-upload="beforeUpload" :on-progress="handleProress"
          :on-success="handleUploadSuccess" drag
          :action="vjEnv.serviceUrl + '/workspace/' + vjEnv.workspace + '/uploads?token=' + vjEnv.accessToken">
          <!-- 还没上传的时候 -->
          <template v-if="!uploading && !importFinished">
            <div class="upload-hascad" v-if="isCad">
              <span>当前项目已存在CAD图纸，是否重新导入？</span>
              <span>重新导入后历史数据将被覆盖，请谨慎操作！</span>
            </div>
            <div class="upload-contnet" v-else>
              <img src="@/assets/img/upload-icon.png" />
              <span class="el-upload__text">将文件拖到此处，或<em>点击上传</em></span>
            </div>
          </template>
          <div class="upload-uploading" v-if="uploading">
            <div class="quan1">
              <div class="quan2" :style="{ width: percent + '%' }"></div>
            </div>
            <span class="tips">正在解析CAD图纸，可能需要花费几分钟，请勿关闭页面</span>
          </div>
          <div class="upload-contnet" v-if="importFinished">
            <img src="@/assets/img/icon_index_book_succ.png" />
            <span class="el-upload__text">CAD图纸导入成功！</span>
          </div>
          <div class="el-upload__tip" slot="tip">只能上传dwg文件，且不超过100M</div>
        </el-upload>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import vjmap from 'vjmap'
// import vjcommon from 'vjcommon'
// import 'vjmap/dist/vjmap.min.css'
import { vjEnv } from '@/utils/config'
import { px2vw, getPolygons } from '@/utils/util'
export default {
  name: 'VjMap',
  props: {
  },
  components: {
  },
  data() {
    return {
      vjEnv: vjEnv,
      importDialogVisible: false,
      dialogVisible: false,
      isEdit: false,
      popup: null,
      center: [],
      importFinished: false,
      percent: 0,
      uploading: false,
      homeProjectId: ''
    }
  },
  computed: {
    isImport() {
      return this.$route.query.import === '1'
    },
    projectId() {
      return this.homeProjectId || this.$route.query.projectId
    },
    projectList() {
      return this.$store.state.projectList
    },
    projectInfo() {
      return this.projectList.find(item => item.projectId === this.projectId) || {}
    },
    isCad() {
      return !!this.projectInfo?.cadId
    },
    mapCenter() {
      return this.$store.getters.mapCenter
    },
    cadEpsg() {
      return this.projectInfo.epsg
    }
  },
  watch: {
    async projectId() {
      this._map.setCenter(this.mapCenter)
      this.clearPolygons()
      if (this.isCad) {
        this.closeCAD()
        const res = await this.openCAD()
        this.addDefaultLayer(res)
      } else {
        this.loadProjectFence()
      }
    }
  },
  created() {
    // this.projectId = this.$route.query.projectId
    this._polygons = []
    this.$event.$on('importCad', this.importCad)
    this.$event.$on('toggleLayer', this.toggleLayer)
    this.$event.$on('renderMap', this.onResize)
    this.$event.$on('onBoardProjectChange', this.onBoardProjectChange)

    if (this.isImport) {
      this.importCad()
    }
  },
  mounted() {
    this.initMap()
  },
  beforeDestroy() {
    this.$event.$off('importCad', this.importCad)
    this.$event.$off('toggleLayer', this.toggleLayer)
    this.$event.$off('renderMap', this.onResize)
    this.$event.$off('onBoardProjectChange', this.onBoardProjectChange)

    this._map && this._map.remove()
  },
  methods: {
    onBoardProjectChange(projectId) {
      this.homeProjectId = projectId
    },
    clearPolygons() {
      if (this._polygons && this._polygons.length) {
        this._polygons.forEach(item => this._map.removeSourceEx(item))
      }
      this._polygons = []
    },
    loadProjectFence() {
      if (!this.projectId) return
      this.$axios.get(this.$apis.project.selectYhProjectMapByProjectId, {
        projectId: this.projectId
      }).then(async (res) => {
        if (res.locationList && res.locationList.length) {
          const polygons = getPolygons(res.locationList)
          polygons.forEach(item => {
            const polygonId = this.addMarkersToPolygon(item[1], item[0], {
              fillColor: '#36cbcb',
              fillOutlineColor: '#36cbcb',
              fillOpacity: 0.5
            })
            this._polygons.push(polygonId)
          })
        }
      })
    },
    addMarkersToPolygon(coordinates, fenceCode, style) {
      const polygon = new vjmap.Polygon({
        data: coordinates,
        fillColor: style.fillColor,
        fillOpacity: style.fillOpacity || 0.8,
        fillOutlineColor: style.fillOutlineColor
      })
      polygon.addTo(this._map)
      return polygon.sourceId
    },
    importCad() {
      this.importDialogVisible = true
    },
    newProject() {
      this.isEdit = false
      this.dialogVisible = true
    },
    editProject() {
      this.isEdit = true // 设置弹窗编辑
      this.dialogVisible = true
      this._map.setCenter(this.mapCenter) // 编辑时首先将地图定位到项目位置
      // 这里还需要做清除的操作以及画线画点的操作
    },
    async initEpsgProj({ longitude, latitude }, mapId) {
      const metadata = await this._svc.metadata(mapId, 'v1')
      const x = longitude
      const y = latitude
      const cadX = String(parseInt(metadata.initCenterX))
      let res = []
      if (cadX.length === 8) {
        const proj = vjmap.transform.getEpsgParam(vjmap.transform.EpsgCrsTypes.CGCS2000, parseInt(cadX.slice(0, 2)))
        res.push(proj)
      } else {
        res = vjmap.transform.getEpsgCode([x, y], vjmap.transform.EpsgCrsTypes.CGCS2000, '')
      }
      for (const item of res) {
        if (item.proj) {
          proj4.defs(item.epsg, item.proj)
        }
        if (x < 180) {
          // 经纬度转 cad投影坐标
          item.convertCoordinate = proj4('EPSG:4326', item.epsg, [x, y])
        } else {
          // cad投影坐标转经纬度
          item.convertCoordinate = proj4(item.epsg, 'EPSG:4326', [x, y])
        }
      }
      return res
    },
    async getMapEpsg({ longitude, latitude }, mapId) {
      const res = await this.initEpsgProj({ longitude, latitude }, mapId)
      const metadata = await this._svc.metadata(mapId)
      const point1 = {
        x: parseFloat(metadata.initCenterX),
        y: parseFloat(metadata.initCenterY)
      }
      if (String(parseInt(point1.x)).length === 8) {
        point1.x = parseFloat(String(point1.x).slice(2))
      }
      for (const i of res) {
        const distance = this.calculateDistance(point1, {
          x: i.convertCoordinate[0],
          y: i.convertCoordinate[1]
        })
        i.distance = distance
      }
      const newEpsgArr = res.sort((a, b) => {
        return a.distance - b.distance
      })
      const cadEpsg = newEpsgArr[0].epsg
      return cadEpsg
      // setEpsgText(JSON.stringify(res, null, 4))
    },
    onActionDraw(type) {
      switch (type) {
        case 'point':
          this.measureCoordinate()
          break

        default:
          break
      }
    },
    setPopupText(text) {
      if (text) {
        if (!this.popup) {
          this.popup = new vjmap.Popup({
            className: 'custom-popup',
            closeOnClick: false,
            closeButton: false
          })
            .setHTML(text)
            .setMaxWidth('500px')
            .trackPointer()
            .addTo(this._map)
        } else {
          this.popup.setHTML(text)
        }
      } else {
        // 如果为空时，则删除popup
        if (this.popup) {
          this.popup.setLngLat([0, 0]) // 取消trackPointer
          this.popup.remove()
          this.popup = null
        }
      }
    },
    createLeaderMarker(lnglat, content) {
      const el = document.createElement('div')
      el.className = 'marker'
      el.style.position = 'absolute'

      const img = document.createElement('div')
      img.style.backgroundImage =
        'url("data:image/png;base64,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")'
      img.style.backgroundRepeat = 'no-repeat'
      img.style.height = '37px'
      img.style.width = '100px'
      img.style.position = 'absolute'
      img.style.left = '-3px'
      img.style.bottom = '-3px'
      img.style.right = '0px'
      el.appendChild(img)

      const panel = document.createElement('div')
      panel.style.height = '50px'
      panel.style.width = '350px'
      panel.style.position = 'absolute'
      panel.style.left = '97px'
      panel.style.top = '-60px'
      panel.style.border = 'solid 1px #8E0EFF'
      panel.style.background = 'linear-gradient(#00ffff, #00ffff) left top,  linear-gradient(#00ffff, #00ffff) left top,     linear-gradient(#00ffff, #00ffff) right bottom,    linear-gradient(#00ffff, #00ffff) right bottom'
      panel.style.backgroundRepeat = 'no-repeat'
      panel.style.backgroundColor = 'rgba(87,255,255, 0.3)'
      panel.style.backgroundSize = '1px 6px, 6px 1px'
      panel.style.fontSize = '18px'
      panel.style.color = '#ffffff'
      panel.innerHTML = `<div style='margin: 15px 5px 15px 5px'>${content}</div>`
      el.appendChild(panel)

      // Add markers to the map.
      const marker = new vjmap.Marker({
        element: el,
        anchor: 'bottom-left'
      })
      marker.setLngLat(lnglat)
        .addTo(this._map)
      return marker
    },
    addMarkersToCoord(coordinates) {
      this.center = coordinates
      let markerTexts = []
      const co = this._map.fromLngLat(coordinates)
      const content = `X: ${co.x.toFixed(8)}, Y: ${co.y.toFixed(8)}`
      const marker = this.createLeaderMarker(coordinates, content)
      markerTexts.push(marker)

      // 给第一个点加一个marker用来删除
      const deletePng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAbNJREFUWEftlrFOAkEQhv9Z4XgJOCrlTgp5ABOhMBoTCws7EzUaeAx5A0sDiYmFxpLGaAkU2KqFArHi4CU4cMccAQN6HHcIwZi7cnd25tt/5maHsOCPFhwfPoAnBarhQFIIccjAkV3qCMhKKct6q1tym1pPAHVVOWMg6+ScgKuYYR7PBaCmKmw5XgLiy4b5NhzkXVVWP4BXa00zTNcXc21oOR4AjAswaX9M2n4u1yLBIoiSbmV0Zcdc0pqd1HdbWwUWDuDqRjMy8lQDM4o54sYRoJcKq6qHclePKnuScQ0pd/RWt2ztVyOhLUFckIwTvWneDiLYnXdVA18O+r/dcNXXIsozCGsMzuhGJ98DUINpAuUAqmhGe33k/JjiG9g4K2ADUFdDOQan7QAIlI8Z7YwP4CvgK/C/FahFlQcwtm0bEeNFa5qJuSpgdT2AzkFyU290H3udMBzYgBD3gnAQa5iFuQJ4eZB6A8ovW/ETgARLmfIyaPZVSZIQRTBdas326Thwx7fAzRA6SREB2l0x2ndTAfTnwH0CrGk4PinY6D5VQHyhNcwbp3N/eyDxduPprH0FPgHEyH4wGIHUYwAAAABJRU5ErkJggg=='
      const el = document.createElement('div')
      el.className = 'marker'
      el.style.backgroundImage =
        `url(${deletePng})`
      el.style.width = '20px'
      el.style.height = '20px'
      el.style.backgroundSize = '100%'
      el.style.cursor = 'pointer'

      el.addEventListener('click', function (e) {
        markerTexts.forEach(m => m.remove())
        markerTexts = []
      })
      // Add markers to the map.
      const deleteMarker = new vjmap.Marker({
        element: el,
        anchor: 'right'
      })
      deleteMarker.setLngLat(coordinates)
        .setOffset([-5, 0])
        .addTo(this._map)
      markerTexts.push(deleteMarker)

      // 给地图发送ESC键消息即可取消，模拟按ESC键
      this._map.fire('keyup', { keyCode: 27 })
      this.setPopupText('')
    },
    // 获取地址信息
    async measureCoordinate() {
      let isDrawing = false
      const point = await vjmap.Draw.actionDrawPoint(this._map, {
        api: {
          // getSnapFeatures: snapObj // 要捕捉的数据项在后面，通过属性features赋值
          getSnapFeatures: {} // 要捕捉的数据项在后面，通过属性features赋值
        },
        updatecoordinate: (e) => {
          if (!e.lnglat) return
          isDrawing = true
          const co = this._map.fromLngLat(e.lnglat)
          const html = `当前坐标:<span style="color: #ff0000"> ${co.x.toFixed(8)}, ${co.y.toFixed(8)}</span>`
          this.setPopupText(html)
        },
        contextMenu: (e) => {
          const ss = new vjmap.ContextMenu({
            event: e.event.originalEvent,
            theme: 'dark', // light
            width: '250px',
            items: [
              {
                label: '确认',
                onClick: () => {
                  // 给地图发送Enter键消息即可取消，模拟按Enter键
                  this._map.fire('keyup', { keyCode: 13 })
                  this.setPopupText('')
                }
              },
              {
                label: '取消',
                onClick: () => {
                  // 给地图发送ESC键消息即可取消，模拟按ESC键
                  this._map.fire('keyup', { keyCode: 27 })
                  this.setPopupText('')
                }
              },
              {
                label: '结束测坐标',
                onClick: () => {
                  // 给地图发送ESC键消息即可取消，模拟按ESC键
                  this._map.fire('keyup', { keyCode: 27 })
                  isDrawing = false
                  this.setPopupText('')
                }
              }
            ]
          })
        }
      })
      if (point.cancel) {
        this.setPopupText('')
        return {
          cancel: true,
          exit: isDrawing === false
        }// 取消操作
      }

      this.addMarkersToCoord(point.features[0].geometry.coordinates)
      return {
        point
      }
    },
    toggleLayer({ type, visible }) {
      if (type === 'gaodeImgSource') {
        if (visible) {
          this._map.showSource('gaodeImgSource')
          this._map.showSource('gaodeImgSourceLabel')
        } else {
          this._map.hideSource('gaodeImgSource')
          this._map.hideSource('gaodeImgSourceLabel')
        }
      } else if (type === 'gaodeRoadSource') {
        if (visible) {
          this._map.showSource('gaodeRoadSource')
        } else {
          this._map.hideSource('gaodeRoadSource')
        }
      } else if (type === 'cadSource') {
        if (visible) {
          this._map.showSource('wms-test-source')
        } else {
          this._map.hideSource('wms-test-source')
        }
      }
    },
    async initMap() {
      // --高德地图(地图数据前端获取)--
      const svc = new vjmap.Service(vjEnv.serviceUrl, vjEnv.accessToken)
      this._svc = svc
      // 根据地图范围建立经纬度投影坐标系
      const prj = new vjmap.LnglatProjection()
      // wgs84坐标
      const coWgs84 = prj.toLngLat(this.mapCenter)
      // 把wgs84转成高德坐标坐标
      const coGCJ02 = vjmap.transform.convert(coWgs84, vjmap.transform.CRSTypes.WGS84, vjmap.transform.CRSTypes.GCJ02)
      // 地图对象
      this._map = new vjmap.Map({
        container: 'map', // DIV容器ID
        style: {
          version: svc.styleVersion(),
          glyphs: svc.glyphsUrl(),
          sources: {
            gaodeRoadSource: {
              type: 'raster',
              tiles: ['https://webrd02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}']
            },
            // 影像无文字注记
            gaodeImgSource: {
              type: 'raster',
              tiles: [
                'https://webst02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=6&x={x}&y={y}&z={z}'
              ]
            },
            // 影像文字注记
            gaodeImgSourceLabel: {
              type: 'raster',
              tiles: [
                'https://webst02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}'
              ]
            }
          },
          layers: [{
            id: 'gaodeRoad',
            type: 'raster',
            source: 'gaodeRoadSource'
          }, {
            id: 'gaodeImg',
            type: 'raster',
            source: 'gaodeImgSource',
            layout: {
              visibility: 'none'
            }
          }, {
            id: 'gaodeImgLabel',
            type: 'raster',
            source: 'gaodeImgSourceLabel',
            layout: {
              visibility: 'none'
            }
          }]
        },
        center: prj.toLngLat(coGCJ02),
        zoom: 15,
        pitch: 0,
        renderWorldCopies: false // 不显示多屏地图
      })

      // 关联服务对象和投影对象
      this._map.attach(svc, prj)
      // 根据地图本身范围缩放地图至全图显示
      await this._map.onLoad()
      this.$event.$emit('mapOnload')

      // 加载proj4库，用于坐标转换
      if (typeof proj4 !== 'object') {
        // 如果没有环境
        await vjmap.addScript([{
          src: 'https://vjmap.com/demo/js/proj4.min.js'
        }])
      }
      if (this.isCad) {
        const res = await this.openCAD()
        await this.addDefaultLayer(res)
      } else {
        this.loadProjectFence()
      }
    },
    analyzingCAD(cadId, epsg, version) {
      return this.$axios.post(this.$apis.project.insertJgCad, {
        cadId,
        projectId: this.projectId,
        epsg: epsg,
        cadVersion: version
      }).then(res => {
        return true
      }).catch(() => {
        return false
      })
    },
    calculateDistance(point1, point2) {
      const deltaX = point2.x - point1.x
      const deltaY = point2.y - point1.y
      const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY)
      return distance
    },
    closeCAD() {
      const layer = this._map.getLayer('wms-test-layer')
      if (layer) {
        this._map.removeLayer('wms-test-layer')
      }
      this._map.removeSourceEx('wms-test-source')
    },
    async addDefaultLayer(res) {
      if (!res) {
        return
      }
      const cadEpsg = this.cadEpsg
      const wmsUrl = this._svc.wmsTileUrl({
        mapid: this.projectInfo.cadId, // 地图id
        layers: res.layer, // 图层名称
        srs: 'EPSG:3857',
        crs: cadEpsg,
        webMapType: 'GCJ02' // 底图是高德地图，所以要选GCJ02,如果是天地图，可以不用填此项
      })
      this._map.addSource('wms-test-source', {
        type: 'raster',
        tiles: [
          wmsUrl
        ],
        tileSize: 256
      })
      this._map.addLayer({
        id: 'wms-test-layer',
        type: 'raster',
        source: 'wms-test-source',
        paint: { 'raster-opacity': 1 }
      }
      )
      await this.initEpsgProj({
        longitude: this.mapCenter[0],
        latitude: this.mapCenter[1]
      }, this.projectInfo.cadId)
      proj4.defs('EPSG:4326', '+proj=longlat +datum=WGS84 +no_defs +type=crs')
      // proj4.defs(cadEpsg, epsgArr[0].proj)
      // cad图坐标转web wgs84坐标，再转火星坐标（高德)
      const cadToWebCoordinate = point => {
        const co = proj4(cadEpsg, 'EPSG:4326', vjmap.geoPoint(point).toArray())
        // 把wgs84转成高德坐标坐标
        const dataaaa = vjmap.transform.convert(co, vjmap.transform.CRSTypes.WGS84, vjmap.transform.CRSTypes.GCJ02)
        return dataaaa
      }
      // // 火星坐标（高德)转web wgs84坐标转cad图坐标
      // const webTocadCoordinate = point => {
      //   const co = vjmap.transform.convert(point, vjmap.transform.CRSTypes.GCJ02, vjmap.transform.CRSTypes.WGS84)
      //   return proj4('EPSG:4326', cadEpsg, co)
      // }
      // 根据cad图的中心点，计算wgs84的中心点坐标
      const mapBounds = vjmap.GeoBounds.fromString(res.bounds)
      const cadCenter = mapBounds.center()
      // if (String(parseInt(cadCenter.x)).length === 8) {
      //   cadCenter.x = parseFloat(String(cadCenter.x).slice(2))
      // }
      const webCenter = cadToWebCoordinate(cadCenter)
      // 把cad图的中点设置为地图的中心点
      this._map.setCenter(webCenter)
    },
    async openCAD(mapid, fileid, uploadname) {
      const mapId = mapid || this.projectInfo.cadId
      let res = null
      try {
        this._svc.switchWorkspace(vjEnv.workspace)
        res = await this._svc.openMap({
          fileid: fileid,
          uploadname,
          mapid: mapId, // 地图ID,(请确保此ID已存在，可上传新图形新建ID)
          mapopenway: vjmap.MapOpenWay.GeomRender, // 以几何数据渲染方式打开
          // mapopenway: vjmap.MapOpenWay.Memory,
          style: vjmap.openMapDarkStyle() // div为深色背景颜色时，这里也传深色背景样式
        })
      } catch (error) {
        console.log('error', error)
        if (error.response && error.response.includes('map not exist')) {
          this.$message({ type: 'error', message: 'cad不存在，请检查' })
        } else {
          this.$message({ type: 'error', message: 'cad打开失败' })
        }
      }
      return res
    },
    async updateCAD(mapid, fileid, uploadname) {
      this._svc.switchWorkspace(vjEnv.workspace)
      let res = null
      try {
        res = await this._svc.updateMap({
          fileid: fileid,
          uploadname,
          mapid: mapid, // 地图ID,(请确保此ID已存在，可上传新图形新建ID)
          // mapopenway: vjmap.MapOpenWay.GeomRender, // 以几何数据渲染方式打开
          mapopenway: vjmap.MapOpenWay.Memory,
          style: vjmap.openMapDarkStyle() // div为深色背景颜色时，这里也传深色背景样式
        })
      } catch (error) {
        this.$message({ type: 'error', message: 'cad更新失败' })
      }
      return res
    },
    beforeUpload(file) {
      const isDWG = file.name.toLowerCase().includes('.dwg')
      const isLt100M = file.size / 1024 / 1024 < 100

      if (!isDWG) {
        this.$message.error('上传文件只能是 DWG 格式!')
      }
      if (!isLt100M) {
        this.$message.error('上传dwg文件大小不能超过 100M!')
      }
      // this._svc.uploadMap(file).then(res => {
      //   console.log('res', res)
      // })
      return isDWG && isLt100M
      // return false
    },
    async handleUploadSuccess(res) {
      let data = {}
      let mapId = ''
      if (this.isCad) {
        mapId = this.projectInfo.cadId
        data = await this.updateCAD(mapId, res.fileid, this.$dayjs().format('YYYY-MM-DD'))
      } else {
        mapId = res.mapid
        data = await this.openCAD(mapId, res.fileid, this.$dayjs().format('YYYY-MM-DD'))
      }
      const epsg = await this.getMapEpsg({
        longitude: this.mapCenter[0],
        latitude: this.mapCenter[1]
      }, mapId)
      // 绑定cad
      const info = await this.analyzingCAD(mapId, epsg, data.version)
      if (!info) {
        this.percent = 0
        this.uploading = false
        this.importFinished = false
        return
      }
      // 刷新项目信息
      await this.$store.dispatch('getProjectList')
      // 打开cad
      this.closeCAD()
      this.addDefaultLayer(data)
      this.percent = 100
      setTimeout(() => {
        this.importFinished = true
        this.percent = 0
        this.uploading = false
      }, 1000)
    },
    handleProress(event) {
      this.uploading = true
      if (event.percent === 100) {
        this.percent = 80
      } else {
        this.percent = event.percent
      }
    },
    cadToWebCoordinate(point) {
      const cadEpsg = this.cadEpsg || 'EPSG:4549' // cad图的espg代号
      const co = proj4(cadEpsg, 'EPSG:4326', point)
      // 把wgs84转成高德坐标坐标
      return vjmap.transform.convert(co, vjmap.transform.CRSTypes.WGS84, vjmap.transform.CRSTypes.GCJ02)
    },
    // 地图自适应展示全部markers，padding为四周留白距离 数值为数字或者对象，eg：10 或 {top: 10, bottom:25, left: 15, right: 5}，maxZoom为最大放大等级
    setFitMarkers(padding, maxZoom) {
      const pd = padding || px2vw(100)
      const mZoom = maxZoom || 18
      const markers = this._map.getMarkers()
      if (markers.length) {
        const pts = markers.map(c => this._map.fromLngLat(c.getLngLat()))
        const showBounds = vjmap.geoBounds()
        showBounds.update(pts) // 得到所有点坐标的范围
        const lngLatBounds = this._map.toLngLat(showBounds)
        this._map.fitBounds(lngLatBounds, {
          padding: pd,
          maxZoom: mZoom,
          duration: 500
        })
      }
    },
    // 地图自适应
    onResize() {
      this.$nextTick(() => {
        this._map && this._map.resize()
      })
    }
  }
}
</script>

<style lang="scss">
.import-window {
  height: 330px;

  .el-dialog__body {
    padding: 20px !important;
  }
}
</style>
<style scoped lang="scss">
.map-content {
  height: 100%;
  position: relative;
}

.map {
  background: #000000;
  height: 100%;
}

.import-content {
  display: flex;
  flex-direction: column;

  .name {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    margin-bottom: 20px;
  }

  .upload-cad {
    width: 400px;
    height: 170px;
    background: #FBFBFB;
    border-radius: 10px;
    border: 1px dashed #C3C3C3;

    ::v-deep {
      .el-upload {
        width: 100%;
        height: 100%;
      }

      .el-upload-dragger {
        width: 100%;
        height: 100%;
        background: transparent;
        border: 0;
      }
    }

    .el-upload__tip {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #000000;
      text-align: center;
      margin-top: 16px;
    }

    .upload-uploading {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .quan1 {
        width: 270px;
        height: 20px;
        background: #F4F4F4;
        border-radius: 10px;
        border: 1px solid #D6D6D6;

        .quan2 {
          height: 18px;
          background: linear-gradient(-90deg, #01E9BD, #007CDE);
          border-radius: 10px;
          transition: .7s;
        }
      }

      .tips {
        width: 177px;
        height: 26px;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #000000;
        margin-top: 26px;
      }
    }
  }

  .upload-hascad {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    span {
      &:nth-child(1) {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
      }

      &:nth-child(2) {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #DE0000;
        margin-top: 19px;
      }
    }
  }

  .upload-contnet {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      margin-bottom: 20px;
    }

    span {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
}
</style>
